<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <div class="row" v-if="gameLoaded">
                <div class="col-md-2">
                  <a-image
                    width="100%"
                    style="max-width: 250px; margin-bottom: 15px"
                    :src="game.picture"
                  />
                </div>
                <div class="col-md-10">
                  <div class="row">
                    <div class="col-md-12">
                      <h4>เกม: {{ game.name }}</h4>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <span>คำอธิบาย: {{ game.desc }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <n-button type="info" @click="backToGame()"
                        >กลับไปเลือกเกม</n-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">แพ็คเกจ</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <n-button type="info" @click="addOrUpdatePackage()"
            >เพิ่มแพ็คเกจ</n-button
          >
          <a-table :columns="columns" :data-source="data" :scroll="{ x: 1000 }">
            <template #price="{ record }">
              <a href="#" @click="addOrUpdatePrice(record.id)">{{
                record.minPrice === record.maxPrice
                  ? record.minPrice
                  : record.minPrice + " - " + record.maxPrice
              }}</a>
            </template>

            <template #payment="{ text: payment }">
              <a-tag
                v-for="p in payment"
                :key="p"
                :color="p === 'bank' ? 'success' : 'processing'"
              >
                {{ p }}
              </a-tag>
            </template>
            <template #status="{ record }">
              <a-tag
                :key="record.isDeleted"
                :color="record.isDeleted ? 'volcano' : 'green'"
              >
                {{ record.isDeleted ? "ไม่ใช้งาน" : "ใช้งาน" }}
              </a-tag>
            </template>
            <template #action="{ record }">
              <a href="#" @click="addOrUpdatePackage(record.id)">แก้ไข</a>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>

  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>

  <a-modal
    destroyOnClose="true"
    v-model:visible="visible"
    title="เพิ่มแพ็คเกจ"
    @ok="handleOk"
    :confirm-loading="confirmLoading"
  >
    <Form
      method="#"
      action="#"
      v-on:submit="onSavePackage"
      :validation-schema="schema"
    >
      <vee-input
        label="ชื่อแพ็คเกจ"
        name="name"
        type="text"
        :value="package.name"
        placeholder="Enter name"
      />
      <vee-input
        label="รายละเอียด"
        name="desc"
        type="text"
        :value="package.desc"
        placeholder="Enter description"
      />
      <br />
      <div class="form-group">
        <checkbox
          v-model="package.checked"
          @change="onIsActiveChange"
          name="isactive"
          >ใช้งาน</checkbox
        >
      </div>
      <button ref="submit" style="display: none">Submit</button>
    </Form>
  </a-modal>

  <a-modal
    destroyOnClose="true"
    v-model:visible="visiblePrice"
    width="1000px"
    title="ราคาขาย - ช่องทางชำระเงิน"
    @ok="handlePriceOk"
    :confirm-loading="confirmPriceLoading"
    :zIndex="1001"
  >
    <a-table
      :columns="price_column"
      :data-source="price_data"
      :scroll="{ x: 1000 }"
    >
      <template #price="{ record }">
        <fg-input>
          <el-input-number
            type="number"
            placeholder="Enter price"
            v-model="record.price"
          >
          </el-input-number>
        </fg-input>
      </template>
      <template #startDate="{ record }">
        <fg-input>
          <a-date-picker
            v-model:value="record.startDate"
            placeholder="Start Date"
            :disabled-date="disabledStartDate"
          />
        </fg-input>
      </template>
      <template #endDate="{ record }">
        <fg-input>
          <a-date-picker
            type="date"
            placeholder="End Date"
            :disabled-date="(e) => disabledEndDate(e, record.startDate)"
            v-model:value="record.endDate"
          />
        </fg-input>
      </template>
      <template #isActived="{ record }">
        <n-switch v-model="record.isActived">
          <template v-slot:on><i class="now-ui-icons ui-1_check"></i></template>
          <template v-slot:off
            ><i class="now-ui-icons ui-1_simple-remove"></i
          ></template>
        </n-switch>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { message } from "ant-design-vue";
import { VeeInput, Checkbox } from "@/components";
import * as Yup from "yup";
import { Form } from "vee-validate";
import { ElDatePicker, ElInputNumber } from "element-plus";
import { Switch } from "@/components/index";
import moment from "moment";
import * as configuration from "../../../middleware/configuration";
import * as gameservice from "../../../services/game";
import * as paymentservice from "../../../services/payment";
import * as packageservice from "../../../services/package";

const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "Pack Id",
    dataIndex: "id",
    key: "id",
    width: 85,
  },
  {
    title: "ชื่อแพ็คเกจ",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "คำอธิบาย",
    dataIndex: "desc",
    key: "desc",
  },
  {
    title: "ราคาขาย",
    key: "price",
    align: "center",
    slots: { customRender: "price" },
    width: 85,
  },
  {
    title: "ข่องทางการชำระเงิน",
    key: "payment",
    dataIndex: "payment",
    align: "center",
    slots: { customRender: "payment" },
  },
  {
    title: "สถานะ",
    key: "status",
    align: "center",
    slots: { customRender: "status" },
    width: 85,
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 85,
  },
];

const price_column = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "ช่องทางการชำระเงิน",
    dataIndex: "paymentmethod",
    key: "paymentmethod",
  },
  {
    title: "ราคา (บาท)",
    key: "price",
    slots: { customRender: "price" },
  },
  {
    title: "วันเริ่มจำหน่าย",
    key: "startDate",
    slots: { customRender: "startDate" },
  },
  {
    title: "วันหมดอายุ",
    key: "endDate",
    slots: { customRender: "endDate" },
  },
  {
    title: "เปิดใช้งาน",
    key: "isActived",
    slots: { customRender: "isActived" },
    width: 120,
  },
];
export default {
  components: {
    [ElDatePicker.name]: ElDatePicker,
    [ElInputNumber.name]: ElInputNumber,
    [Switch.name]: Switch,
    Checkbox,
    Form,
    VeeInput,
  },
  methods: {
    async getGames() {
      try {
        let res = await gameservice.get("games/master");
        this.games = res.data;
        this.game = res.data.find((x) => x.id == this.$route.params.id);
      } catch (error) {
        console.log(error);
      } finally {
        this.gameLoaded = true;
      }
    },
    async getPaymentMethods() {
      try {
        let res = await paymentservice.getPaymentMethods();
        this.paymentMethods = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.paymentLoaded = true;
      }
    },
    async getPackage() {
      try {
        let res = await packageservice.getPackage('master/' + this.id);
        let count = 1;
        res.data.map((l) => {
          l.no = count++;
          let masterPackage = l.masterPackage.filter((f) => f.isActived);
          const maxPeak =
            l.masterPackage.length === 0 || masterPackage.length == 0
              ? 0
              : masterPackage.reduce((p, c) => (p.price > c.price ? p : c));
          const minPeak =
            l.masterPackage.length === 0 || masterPackage.length == 0
              ? 0
              : masterPackage.reduce((p, c) => (p.price < c.price ? p : c));
          l.maxPrice = maxPeak === 0 ? 0 : maxPeak.price;
          l.minPrice = minPeak === 0 ? 0 : minPeak.price;
          l.payment =
            l.masterPackage.length === 0
              ? []
              : l.masterPackage
                  .filter((f) => f.isActived)
                  .map((x) => x.payment);
        });
        this.data = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.packageLoaded = true;
      }
    },
    addOrUpdatePackage(id = 0) {
      if (id !== 0) {
        let data = this.data.find((x) => x.id === id);
        (this.package.id = id),
          (this.package.name = data.name),
          (this.package.desc = data.desc),
          (this.package.checked = !data.isDeleted);
      } else {
        (this.package.id = id),
          (this.package.name = ""),
          (this.package.desc = ""),
          (this.package.checked = true);
      }
      this.visible = true;
      this.confirmLoading = false;
    },
    addOrUpdatePrice(id) {
      let price_data = [];
      let data = this.data.find((f) => f.id === id);
      this.paymentMethods.map((x, i) => {
        let masterPackage = data.masterPackage.find(
          (f) => f.paymentCode === x.code
        );
        if (masterPackage !== undefined) {
          price_data.push({
            packageId: id,
            id: masterPackage.id,
            no: i + 1,
            code: x.code,
            paymentmethod: x.name,
            price: masterPackage.price,
            startDate: masterPackage.startDateSale,
            endDate: masterPackage.endDateSale,
            isActived: masterPackage.isActived,
          });
        } else {
          price_data.push({
            packageId: id,
            id: 0,
            no: i + 1,
            code: x.code,
            paymentmethod: x.name,
            price: 0,
            startDate: moment().startOf("day"),
            endDate: moment().endOf("year"),
            isActived: false,
          });
        }
      });
      this.price_data = price_data;
      this.visiblePrice = true;
    },
    handleOk(e) {
      this.$refs.submit.click();
    },
    handlePriceOk(e) {
      let data = this.price_data;
      let err = 0;
      data.map((x) => {
        if (parseInt(x.price) < 0 || x.price === undefined || x.price === "") {
          message.warning(`กรุณาใส่ข้อมูลราคา ${x.paymentmethod} ให้ถูกต้อง`);
          err++;
        }

        if (x.price !== undefined && x.price !== "" && x.price % 2 !== 0) {
          message.warning(
            `กรุณาใส่ข้อมูลราคา ${x.paymentmethod} เป็นจำนวนเต็ม`
          );
          err++;
        }

        if (x.isActived && (x.price == "" || x.startDate == "")) {
          message.warning(`กรุณาใส่ข้อมูล ${x.paymentmethod} ให้ครบ`);
          err++;
        }

        let startDate = "";
        if (x.startDate !== null) {
          if (typeof x.startDate === "string")
            startDate = moment(x.startDate).startOf("day");
          else startDate = moment(x.startDate.toISOString()).startOf("day");
        }

        let endDate = "";
        if (x.endDate !== null) {
          if (typeof x.endDate === "string")
            endDate = moment(x.endDate).startOf("day");
          else endDate = moment(x.endDate.toISOString()).startOf("day");
        }
        if (startDate > endDate && !(startDate === "" || endDate === "")) {
          message.warning(
            `วันเริ่มจำหน่าย ${x.paymentmethod} มากกว่า วันหมดอายุ`
          );
          err++;
        }

        x.startDate = startDate._isValid ? startDate.endOf("day") : "";
        x.endDate = endDate._isValid ? endDate.endOf("day") : "";

        if (x.startDate === "" || x.endDate === "") {
          message.warning(
            `วันเริ่มจำหน่าย, หมดอายุ ${x.paymentmethod} ต้องไม่ว่าง`
          );
          err++;
        }
      });
      if (err > 0) return;
      this.onSavePrice();
    },
    async onSavePackage(values) {
      this.confirmLoading = true;
      var data = {
        id: this.package.id,
        gameId: this.$route.params.id,
        name: values.name,
        desc: values.desc,
        isDeleted: !this.package.checked,
      };
      try {
        let res = await packageservice.savePackage(data);
        this.visible = false;
        message.success(`บันทึก ${data.name} สำเร็จ`);
      } catch (error) {
        message.error(`บันทึก ${data.name} ไม่สำเร็จ กรุณาลองอีกครั้ง`);
      } finally {
        await this.getPackage();
        this.confirmLoading = false;
      }
    },
    async onSavePrice() {
      this.confirmPriceLoading = true;
      var data = this.price_data;

      try {
        let res = await packageservice.savePrice(data);
        if (res) {
          this.visiblePrice = false;
          message.success(`บันทึกช่องทางชำระเงินสำเร็จ`);
        }
      } catch (error) {
        message.error(`บันทึกช่องทางชำระเงินไม่สำเร็จ กรุณาลองอีกครั้ง`);
      } finally {
        await this.getPackage();
        this.confirmPriceLoading = false;
      }
    },
    backToGame() {
      this.$router.push("/management/game");
    },
    goToHome() {
      this.$router.push("/game");
    },
    disabledStartDate(current) {
      if (current && current < moment().startOf("day")) {
        return current < moment(current._i).startOf("day");
      } else return current && current < moment().startOf("day");
    },
    disabledEndDate(current, startDate) {
      if (current && current < moment().startOf("day")) {
        return current && current < moment().startOf("day");
      } else if (startDate !== "" && startDate !== null) {
        if (typeof startDate === "string")
          return current < moment(startDate).startOf("day");
        else return current < moment(startDate.toISOString()).startOf("day");
      }
    },
  },

  data() {
    return {
      id: this.$route.params.id,
      gameLoaded: false,
      game: null,
      games: [],
      data: [],
      uid: "",
      paymentMethods: [],
      price_data: [],
      packageLoaded: false,
      paymentLoaded: false,
      columns: columns,
      price_column: price_column,
      visible: false,
      visiblePrice: false,
      canAccess: null,
      role: "customer",
      package: {
        id: 0,
        name: "",
        desc: "",
        checked: true,
      },
      confirmLoading: false,
      confirmPriceLoading: false,
      datePickerOptions: {
        disabledDate(date) {
          var times = Date.now();
          return date.getTime() > times;
        },
      },
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let result = await configuration.getIdTokenResult();
    if (result) {
      this.role = result.claims?.role || this.role;
      if (this.role === "admin" || this.role === "manager") {
        this.getGames();
        this.getPackage();
        this.getPaymentMethods();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required().label("The Name"),
      desc: Yup.string().label("The Desc"),
      isactive: Yup.bool().label("The isactive"),
    });
    return {
      schema,
    };
  },
};
</script>

<style>
</style>